import React, { FC } from 'react';
import { Button } from '@design-system/button';
import { HeadingBlock } from '@design-system/heading-block';
import { Typography } from '@design-system/typography';

import { AirwickNewsletterThankYouProps } from '../models';

export const AirwickNewsletterThankYou: FC<AirwickNewsletterThankYouProps> = ({
  headline,
  description,
  closeButton,
  onCloseThankYou,
}) => (
  <section className="info thank-you">
    <HeadingBlock
      className="newsletter-headline"
      headlineTag="h3"
      headlineVariant="headline"
      headlineSize="m"
      headlineWeight="medium"
      align="center"
      headline={headline}
    />
    <div className="thank-you__description-block">
      <Typography
        variant="body"
        tag="span"
        size="m"
        weight="regular"
        content={description}
        key={description}
      />
    </div>
    <Button
      type="button"
      size="small"
      variant="primary"
      aria-label="close"
      onClick={onCloseThankYou}
    >
      {closeButton.label}
    </Button>
  </section>
);
